export class CashRegModel {
    cashreg_sequence: number
    client_no: number
    method_of_pay: number
    cashreg_date: string
    amount_of_pay: number
    payment_desc: string
    check_card: string
    cashier: string
    cashreg_check: string
    max_cashreg_date: string

    constructor(
        cashreg_sequence: number,
        client_no: number,
        method_of_pay: number,
        cashreg_date: string,
        amount_of_pay: number,
        payment_desc: string,
        check_card: string,
        cashier: string,
        cashreg_check: string,
        max_cashreg_date: string
    ) {
        this.cashreg_sequence = cashreg_sequence
        this.client_no = client_no
        this.method_of_pay = method_of_pay
        this.cashreg_date = cashreg_date
        this.amount_of_pay = amount_of_pay
        this.payment_desc = payment_desc
        this.check_card = check_card
        this.cashier = cashier
        this.cashreg_check = cashreg_check
        this.max_cashreg_date = max_cashreg_date
    }
}